import { useEffect, useState } from 'react';
import { getCampaignSections } from '../api/campaigns';

/**
 * 홈 상단 섹션(/v1/campaigns/sections).
 * 서버가 섹션 제목 · 레이아웃(GRID | HORIZONTAL) · 배너까지 내려주므로 그대로 그린다.
 * 실패해도 아래 전체 목록은 정상 동작해야 하므로 조용히 빈 배열로 떨어뜨린다.
 */
export function useHomeSections() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getCampaignSections()
      .then((data) => { if (!cancelled) setSections(data?.sections ?? []); })
      .catch(() => { if (!cancelled) setSections([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { sections, loading };
}
